import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { section7Validation } from "../../Constant/constant";
import Spinner from "../../Layouts/Spinner";
import {
  getSectionfaqDataSingleId,
  updateSectionfaqData,
} from "../../../redux/cms/action";

const SectionfaqUpdate = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const section5Data = useSelector(
    (state) => state?.reusableSlice?.getsinglefaq
  );
  const numbers = Array.from({ length: 100 }, (_, i) => ({ number: i + 1 }));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: section5Data?.title || "",
      sub_title: section5Data?.sub_title || "",
      ar_title: section5Data?.ar_title || "",
      ar_sub_title: section5Data?.ar_sub_title || "",
      position: section5Data?.position || "",
    },
    validationSchema: section7Validation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    try {
      const data = {
        ...values,
        id: section5Data?.id,
        section: section5Data?.section,
        status: 1,
      };
      dispatch(updateSectionfaqData(data, setLoading, navigate));
    } catch (error) {
      console.error("Submit Error:", error);
    }
  };

  useEffect(() => {
    if (id) {
      dispatch(getSectionfaqDataSingleId(id));
    }
  }, [id]);

  return (
    <div className="p-3">
      <div className=" category-wrapper">
        <form onSubmit={formik.handleSubmit}>
          <div className="d-flex justify-content-between align-items-center pb-5">
            <h3>Update FAQ</h3>
          </div>

          <div className="box-shadowsec">
            <div className="row  justify-content-between">
              <div className="col-md-12 form-group">
                <label>Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter title"
                  name="title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.title}
                />
                {formik.touched.title && formik.errors.title ? (
                  <div className="error">{formik.errors.title}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Ar Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter ar title"
                  name="ar_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ar_title}
                />
                {formik.touched.ar_title && formik.errors.ar_title ? (
                  <div className="error">{formik.errors.ar_title}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Sub Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter sub title"
                  name="sub_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.sub_title}
                />
                {formik.touched.sub_title && formik.errors.sub_title ? (
                  <div className="error">{formik.errors.sub_title}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Ar Sub Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter ar sub title"
                  name="ar_sub_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ar_sub_title}
                />
                {formik.touched.ar_sub_title && formik.errors.ar_sub_title ? (
                  <div className="error">{formik.errors.ar_sub_title}</div>
                ) : null}
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="status">Position</label>
                <select
                  id="position"
                  title="position"
                  className="form-control"
                  onChange={(e) => {
                    formik.setFieldValue("position", Number(e.target.value));
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.position}
                >
                  <option value="">Select Position</option>
                  {numbers?.map((e) => {
                    return <option>{e?.number}</option>;
                  })}
                </select>
                {formik.touched.position && formik.errors.position ? (
                  <div className="error">{formik.errors.position}</div>
                ) : null}
              </div>
            </div>
          </div>
          <div
            className="d-flex align-items-center justify-content-center  "
            style={{ columnGap: "20px" }}
          >
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              onClick={() => {
                navigate("/sectionfaq");
              }}
            >
              Back
            </button>
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              type="submit"
            >
              {!loading ? "Update" : <Spinner />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SectionfaqUpdate;
